import React from 'react';
import { subscribe } from 'reffects-store';
import {
    currencySymbolSelector,
    formDataSelector,
    minCpsSelector,
} from 'components/UnifiedCampaignForm/selectors';
import { dispatch } from 'reffects';
import { i18n } from 'utils/translate';
import CollapsibleLink from '../../../library/CollapsibleLink/CollapsibleLink';
import CurrencyInput from '../../../library/Input/CurrencyInput/CurrencyInput';
import Radio from '../../../library/Input/Radio/Radio';

function CpcMobileForm({
    isCustomCpcMobile,
    showCpcAdvancedOptions,
    formData,
    currencySymbol,
    minCpcPremium,
    setCustomCpcMobile,
    onInputChange,
    onBlur,
}) {
    const { cpcMobile } = formData;
    return (
        <CollapsibleLink
            text={i18n('g_advanced_options')}
            collapsed={!showCpcAdvancedOptions}
        >
            <Radio
                id="radio-cpc-mobile-same"
                value="cpc-mobile-same"
                checked={!isCustomCpcMobile}
                name="radio-group-cpc-mobile"
                onChange={() => setCustomCpcMobile(false)}
            >
                {i18n('campaign_same_cpc_for_mobile')}
            </Radio>
            <Radio
                id="radio-cpc-mobile-custom"
                value="cpc-mobile-custom"
                name="radio-group-cpc-mobile"
                checked={isCustomCpcMobile}
                onChange={() => setCustomCpcMobile(true)}
            >
                {i18n('campaign_custom_cpc_for_mobile')}
            </Radio>
            {isCustomCpcMobile ? (
                <CurrencyInput
                    className="CampaignForm__cpc-mobile"
                    name="cpcMobile"
                    label={i18n('cpc_mobile_thribee')}
                    value={cpcMobile}
                    symbol={currencySymbol}
                    min={minCpcPremium}
                    step={0.01}
                    required
                    onChange={onInputChange}
                    onBlur={onBlur}
                />
            ) : null}
        </CollapsibleLink>
    );
}

export default subscribe(
    CpcMobileForm,
    function mapStateToProps(state) {
        return {
            isCustomCpcMobile: state.isCustomCpcMobile,
            showCpcAdvancedOptions: state.showCpcAdvancedOptions,
            formData: formDataSelector(state),
            currencySymbol: currencySymbolSelector(state),
            minCpcPremium: minCpsSelector(state),
        };
    },
    {
        onInputChange(e) {
            dispatch({
                id: 'UPDATE_CAMPAIGN_FORM',
                payload: {
                    [e.target.name]: e.target.value,
                },
            });
        },
        formatDecimalOnInputBlur(e) {
            dispatch({
                id: 'FORMAT_INPUT_DECIMALS',
                payload: {
                    name: e.target.name,
                    value: e.target.value,
                },
            });
        },
        setCustomCpcMobile(active) {
            dispatch({
                id: 'SET_CUSTOM_CPC_MOBILE_OPTION',
                payload: { isCustomCpcMobile: active },
            });
        },
    }
);
